<template>
  <div class="ring-box">
    <!-- 饼图 -->
    <div id="ring" ref="ringContainer" v-show="ispie && userLevel > 1"
         :class="{ 'ring-shift': currentBrandDetail }"/>
    <!-- 详情面板 -->
    <div id="brand-detail-panel" v-if="ispie && userLevel > 1 && currentBrandDetail">
      <div class="detail-header">
        <span class="detail-title">{{ currentBrandDetail.brandName }}</span>
        <span class="detail-close" @click="closeDetail">×</span>
      </div>
      <div class="detail-content">
        <div class="detail-row">
          <span class="detail-label">运营企业：</span>
          <!-- 使用 el-tooltip 悬浮显示全称 -->
          <el-tooltip
            :content="currentBrandDetail.companyName || '-'"
            placement="top">
            <!-- 文本容器：限制宽度以触发省略号 -->
            <span
              ref="textRef"
              class="detail-value ellipsis-text">
              {{currentBrandDetail.companyName.slice(0, currentBrandDetail.companyName.length - 4) + '...'}}
            </span>
          </el-tooltip>
        </div>
        <div class="detail-row">
          <span class="detail-label">联系人：</span>
          <span class="detail-value">{{ currentBrandDetail.contactPerson || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">联系电话：</span>
          <span class="detail-value">{{ currentBrandDetail.contactPhone || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">运维人数：</span>
          <span class="detail-value">{{ currentBrandDetail.opsCount || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">核定量数：</span>
          <span class="detail-value">{{ currentBrandDetail.verifyCount || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">运营区域：</span>
          <span class="detail-value">{{ currentBrandDetail.operationArea || '-' }}</span>
        </div>
      </div>
    </div>
    <!-- 统计区 -->
    <div class="content" v-if="!ispie && statisticals">
      <div class="flex-1">
        <div class="title">
          <div>共享自行车</div>
          <div>
            <span>投放总量：{{ statisticals.bikeNum }}</span>
            <span class="pr10">站点车辆：{{ statisticals.bSiteNumTotal }}</span>
          </div>
        </div>
        <div class="flex">
          <div class="flex-1">
            <template
              v-if="statisticals && statisticals.bike && statisticals.bike.length"
            >
              <div
                class="num"
                v-for="(item, index) in statisticals.bike"
                :key="'bike' + index"
              >
                <span class="gray-a">{{ item && item.brandName }}：</span>
                <span class="gray-a">{{ item.onlineNum }}</span>
                <span
                  v-show="item.onlineNum && item.brandEBikeNum"
                  :class="{
                    red: item.onlineNum / item.brandBikeNum > 1,
                    blue: item.onlineNum / item.brandBikeNum <= 1,
                  }"
                >{{
                    item.brandBikeNum
                      ? parseInt(
                        Math.floor(
                          Number(item.onlineNum / item.brandBikeNum) *
                          100 *
                          100
                        ) / 100
                      )
                      : 0
                  }}%</span
                >
                <span class="gray-a">{{ item.siteNum }}</span>
                <span @click="filterBike(item.brandId, 0)">查看</span>
              </div>
            </template>
            <template v-else>
              <div class="gray-a" style="margin-bottom: 15px">暂无数据</div>
            </template>
          </div>
        </div>
      </div>
      <div class="flex-1">
        <div class="title">
          <div>共享电动车</div>
          <div>
            <span>投放总量：{{ statisticals.ebikeNum }}</span>
            <span class="pr10">站点车辆：{{ statisticals.eSiteNumTotal }}</span>
          </div>
        </div>
        <div class="flex">
          <div class="flex-1">
            <template
              v-if="
                statisticals && statisticals.ebike && statisticals.ebike.length
              "
            >
              <div
                class="num"
                v-for="(item, index) in statisticals.ebike"
                :key="'ebike' + index"
              >
                <span class="gray-a">{{ item && item.brandName }}：</span>
                <span class="gray-a">{{ item.onlineNum }}</span>
                <span
                  v-show="item.onlineNum && item.brandEBikeNum"
                  :class="{
                    red: item.onlineNum / item.brandEBikeNum > 1,
                    blue: item.onlineNum / item.brandEBikeNum <= 1,
                  }"
                >{{
                    item.brandEBikeNum
                      ? parseInt(
                        Math.floor(
                          Number(item.onlineNum / item.brandEBikeNum) *
                          100 *
                          100
                        ) / 100
                      )
                      : 0
                  }}%</span
                >
                <span class="gray-a">{{ item.siteNum }}</span>
                <span @click="filterBike(item.brandId, 1)">查看</span>
              </div>
            </template>
            <template v-else>
              <div class="gray-a" style="margin-bottom: 15px">暂无数据</div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart, registerShape } from '@antv/g2'
import Api from '@/api'
import { mapGetters } from 'vuex'

export default {
  name: 'TotalRingChart',
  data() {
    return {
      Circle1: null,
      realNames: [],
      timer: null,
      cData: [],
      onlineTotal: 0,
      // 单车品牌颜色
      brandOriginColor: {},
      // 电动车品牌颜色
      eOriginColor: {},
      // 新增：品牌详情数据
      brandDetails: {},
      // 当前选中的品牌详情
      currentBrandDetail: null,
      // 品牌详情映射（品牌名 -> 详情数据）
      brandDetailMap: {}
    }
  },
  computed: {
    ...mapGetters(['userLevel', 'userBikeType']),
    statisticals() {
      const arr = this.statistical
      if (arr.bike && arr.bike.length > 0) {
        arr.bike = arr.bike
          .filter((val) => val.onlineNum)
          .map((val) => {
            val.brandName = val.brandName.slice(0, 2) + '单车'
            return val
          })
      }
      if (arr.ebike && arr.ebike.length > 0) {
        arr.ebike = arr.ebike.filter((val) => val.onlineNum)
      }
      return arr
    },
    isBicycle() {
      // 判断用户账号属性为自行车或者包含电动车及自行车
      return (this.userBikeType === 0 || this.userBikeType === 2)
    },
    isElectricBike() {
      // 判断用户账号属性为电动车或者包含电动车及自行车
      return (this.userBikeType === 1 || this.userBikeType === 2)
    }
  },
  props: {
    ispie: {
      type: Boolean,
      default: true
    },
    statistical: {
      type: Object,
      default() {
        return {}
      }
    },
    selfAreaId: {
      default: '',
      type: String
    }
  },
  watch: {
    selfAreaId(v, o) {
      if (this.selfAreaId !== '') {
        this.getAreaBrandDetails()
        this.initCircle1Data()
          .then(() => {
            this.initCircle1Data()
          })
      }
    },
    ispie(v) {
      if (v) {
        this.$nextTick(() => {
          this.getAreaBrandDetails()
          setTimeout(() => {
            this.initCircle1(this.cData, this.onlineTotal)
          }, 500)
        })
      }
    }
  },
  mounted() {
    if (this.selfAreaId !== '') {
      this.getAreaBrandDetails()
        .then(() => {
          this.initCircle1Data()
        })
    }
  },
  created() {
    this.getAreaBrandDetails()
  },
  methods: {
    // 获取品牌详情
    async getBrandDetail(brandId) {
      try {
        // 如果有缓存，直接使用缓存
        if (this.brandDetailMap[brandId]) {
          this.showBrandDetail(this.brandDetailMap[brandId])
          return
        }
        const params = {
          selfAreaId: this.selfAreaId,
          brandId: brandId
        }
        const res = await Api.getBrandInfoById(params)
        if (res.code === 200 && res.data) {
          // 缓存数据
          this.brandDetailMap[brandId] = res.data
          this.showBrandDetail(res.data)
        } else {
          // 接口返回空，显示默认信息
          this.showBrandDetail(null, brandId)
        }
      } catch (e) {
        console.error('获取品牌详情失败:', e)
        // 出错时显示默认信息
        this.showBrandDetail(null, brandId)
      }
    },

    // 显示品牌详情
    showBrandDetail(detail, fallbackBrandId) {
      if (detail) {
        this.currentBrandDetail = {
          brandId: detail.brandId || fallbackBrandId,
          brandName: detail.brandName || '未知品牌',
          companyName: detail.brandOperation || '-',
          contactPerson: detail.brandContactPerson || '-',
          contactPhone: detail.brandContactMobile || '-',
          opsCount: detail.brandOperationNum || '-',
          verifyCount: detail.brandAreaEleBikeNum || '-',
          operationArea: detail.operationAreaName || '-',
          // 运营区域 ID，用于查询区域围栏
          operationAreaId: detail.operationAreaId || ''
        }
        // 【新增】详情拿到后，通知地图展示该品牌运营区域的围栏
        this.$emit('brandFenceChange', {
          brandId: detail.brandId || fallbackBrandId,
          operationAreaId: detail.operationAreaId || '',
          brandName: detail.brandName || ''
        })
      } else {
        // 如果没有获取到详情，显示默认信息
        this.currentBrandDetail = {
          brandId: fallbackBrandId || '',
          brandName: '暂无数据',
          companyName: '暂无数据',
          contactPerson: '暂无数据',
          contactPhone: '暂无数据',
          opsCount: '暂无数据',
          verifyCount: '暂无数据',
          operationArea: '暂无数据',
          operationAreaId: ''
        }
        this.$emit('brandFenceChange', null)
      }
    },
    // 关闭详情面板
    closeDetail() {
      this.currentBrandDetail = null
      // 取消选中时通知地图恢复初始状态
      this.$emit('brandFenceChange', null)
    },
    initCircle1(cData, total) {
      const vm = this
      vm.closeDetail()
      // 可以通过调整这个数值控制分割空白处的间距，0-1 之间的数值
      const sliceNumber = 0.002
      // // 自定义 other 的图形，增加两条线
      registerShape('interval', 'slice-shape', {
        draw(cfg, container) {
          const points = cfg.points
          let path = []
          path.push(['M', points[0].x, points[0].y])
          path.push(['L', points[1].x, points[1].y - sliceNumber])
          path.push(['L', points[2].x, points[2].y - sliceNumber])
          path.push(['L', points[3].x, points[3].y])
          path.push('Z')
          path = this.parsePath(path)
          return container.addShape('path', {
            attrs: {
              fill: cfg.color,
              path
            }
          })
        }
      })
      if (vm.Circle1) {
        vm.Circle1.destroy()
        vm.Circle1 = null
      }
      // 使用 $refs 获取容器
      const ringContainer = this.$refs.ringContainer
      if (!ringContainer) {
        console.warn('ring容器不存在，延迟重试')
        setTimeout(() => this.initCircle1(cData, total), 300)
        return
      }
      // 清空容器
      ringContainer.innerHTML = ''
      // 确保容器有尺寸
      const rect = ringContainer.getBoundingClientRect()
      if (rect.width === 0 || rect.height === 0) {
        console.warn('ring容器尺寸为0，延迟重试')
        setTimeout(() => this.initCircle1(cData, total), 300)
        return
      }
      // 创建图表，使用 ref
      vm.Circle1 = new Chart({
        container: ringContainer,  // 直接传入DOM元素
        autoFit: true,
        // 可以设置最小尺寸保证显示
        width: rect.width || 400,
        height: rect.height || 220
      })
      // 颜色指定
      var colorArr = this.getColorsByNames()
      // 存储所有原始数据
      const allData = cData.slice()
      // 当前选中的图例名称数组（高亮显示的图例）
      let selectedItems = []
      function buildSegments(list) {
        const segments = []
        list.forEach((d) => {
          const percent = Number(d.percent) || 0
          const baseColor = colorArr[d.type] || vm.color16()
          const deepColor = vm.darkenColor(baseColor, 0.25)

          // 整段 label 的 HTML，超标时整体闪烁
          const labelHtml = percent > 100
            ? `<span style="font-weight:bold;color:#f5222d;animation:tidal-percent-blink 0.8s infinite;">${d.type}: ${percent}%</span>`
            : `<span style="font-weight:bold;color:#fff;">${d.type}: ${percent}%</span>`

          if (percent <= 100) {
            segments.push({
              ...d,
              labelHtml,
              segKey: d.type + '_normal',
              segType: d.type,
              segColor: baseColor,
              bili: d.bili
            })
          } else {
            const normalRatio = 100 / percent
            const overRatio = (percent - 100) / percent

            segments.push({
              ...d,
              labelHtml,
              segKey: d.type + '_normal',
              segType: d.type,
              segColor: baseColor,
              bili: d.bili * normalRatio
            })
            segments.push({
              ...d,
              labelHtml,
              segKey: d.type + '_over',
              segType: d.type,
              segColor: deepColor,
              bili: d.bili * overRatio,
              isOver: true
            })
          }
        })
        return segments
      }
      function buildChart(data, onlineTotal) {
        // 1. 销毁旧图表
        if (vm.Circle1) {
          vm.Circle1.destroy()
          vm.Circle1 = null
        }
        // 2. 清空容器
        const ringEl = document.getElementById('ring')
        if (ringEl) {
          ringEl.innerHTML = ''
        }

        // 3. 创建新图表 - 添加 height 参数
        vm.Circle1 = new Chart({
          container: 'ring',
          //   height: chartHeight,  // 添加高度
          autoFit: true
        })
        const segData = buildSegments(data)
        vm.Circle1.data(segData)
        vm.Circle1.coordinate('theta', {
          radius: 0.8, // 控制环形图大小，值越小环形图越小
          innerRadius: 0.6 // 控制内径，值越大环形越细
        })
        // ===== 禁用 G2 自带的图例 =====
        vm.Circle1.legend(false)
        vm.Circle1.tooltip({
          showTitle: false,
          showMarkers: false,
          itemTpl: `<li class="g2-tooltip-list-item" style='background:transparent'>
        <span style="background-color:{segColor};" class="g2-tooltip-marker"></span>
        {labelHtml}
          <p style="margin-top:10px;margin-left:20px;">在线量{online}辆</p>
          <p style="margin-top:10px;margin-left:20px;">核定量{setCount}辆</p>
          <p style="margin-top:10px;margin-left:20px;color:#00DADA;text-decoration: underline;" >站点车辆{inSite}辆</p>
        </li>`
        })
        // 中间文字：总在线量数值
        vm.Circle1.annotation()
          .text({
            position: ['50%', '50%'],
            content: onlineTotal,
            style: {
              fontSize: 26,
              lineWidth: 0.1,
              fill: '#fff',
              textAlign: 'center'
            },
            offsetY: -10
          })
          .text({
            position: ['50%', '50%'],
            content: '总在线量',
            style: {
              fontSize: 14,
              fill: '#fff',
              lineWidth: 0.1,
              textAlign: 'center'
            },
            offsetX: 0,
            offsetY: 10
          })
        const hasSelection = selectedItems.length > 0
        vm.Circle1.interval()
          .style({
            stroke: 'white',
            lineWidth: 1
          })
          .adjust('stack')
          .position('bili')
          // 使用函数根据品牌名称返回对应颜色
          .color('segKey', (segKey) => {
            // 找到对应 segment 的颜色
            const seg = segData.find(s => s.segKey === segKey)
            const baseColor = seg ? seg.segColor : '#ccc'
            const segType = seg ? seg.segType : ''

            // 没有选中：全部正常显示
            if (!hasSelection) return baseColor
            // 选中项：正常颜色
            if (selectedItems.includes(segType)) return baseColor
            // 未选中项：浅灰
            return '#E8E8E8'
          })
          .tooltip(
            'segType*percent*labelHtml*online*inSite*setCount*segColor',
            (segType, percent, labelHtml, online, inSite, setCount, segColor) => ({
              segType, percent, labelHtml, online, inSite, setCount, segColor
            })
          )
          .shape('slice-shape')
        vm.Circle1.render()
      }
      // 初始显示总在线量
      const initialTotal = allData.reduce((sum, item) => sum + (item.online || 0), 0)
      buildChart(allData, initialTotal)
      // 更新图表（计算数据 + 重建）
      function updateChart() {
        let newData
        let onlineTotal = 0
        if (selectedItems.length === 0) {
          newData = allData
          onlineTotal = allData.reduce((sum, item) => sum + (item.online || 0), 0)
        } else {
          newData = allData.filter(d => selectedItems.includes(d.type))
          onlineTotal = newData.reduce((sum, item) => sum + (item.online || 0), 0)
        }
        buildChart(newData, onlineTotal)
      }
      // ===== 创建自定义图例（放在 ring-box 外部） =====
      // 等待 DOM 渲染完成
      this.$nextTick(() => {
        // 获取 ring-box 容器
        const ringBox = document.querySelector('.ring-box')
        if (!ringBox) return
        // 移除旧的图例容器（如果存在）
        const oldLegend = document.getElementById('custom-legend-container')
        if (oldLegend) {
          oldLegend.remove()
        }
        // 创建自定义图例容器
        const legendContainer = document.createElement('div')
        legendContainer.id = 'custom-legend-container'
        // 将图例添加到 ring-box 中
        ringBox.appendChild(legendContainer)
        // 渲染图例
        function renderLegend() {
          legendContainer.innerHTML = ''
          if (allData.length === 0) {
            const emptyText = document.createElement('span')
            emptyText.textContent = '暂无数据'
            emptyText.style.color = 'rgba(255,255,255,0.5)'
            emptyText.style.fontSize = '12px'
            legendContainer.appendChild(emptyText)
            return
          }
          allData.forEach((d, index) => {
            const isActive = selectedItems.length === 0 || selectedItems.includes(d.type)
            const color = colorArr[d.type] || '#ccc'
            // 判断总量是否超过 100%
            const isOver = Number(d.percent) > 100
            // 图例项容器
            const itemDiv = document.createElement('div')
            itemDiv.style.display = 'flex'
            itemDiv.style.alignItems = 'center'
            itemDiv.style.cursor = 'pointer'
            itemDiv.style.userSelect = 'none'
            itemDiv.style.opacity = isActive ? '1' : '0.9' // 数值越大图例置灰会亮
            itemDiv.style.transition = 'all 0.3s ease'
            itemDiv.style.padding = '4px 12px'
            itemDiv.style.borderRadius = '4px'
            itemDiv.style.position = 'relative'
            // 固定高度，防止抖动
            itemDiv.style.height = '15px'
            // 超过 100% 时，整个图例项闪烁
            if (isOver) {
              itemDiv.style.animation = 'legend-blink 0.8s infinite'
            }
            // 颜色标记
            const marker = document.createElement('span')
            marker.style.width = '10px'
            marker.style.height = '10px'
            marker.style.display = 'inline-block'
            marker.style.marginRight = '8px'
            marker.style.borderRadius = '50%'
            marker.style.backgroundColor = color
            marker.style.transition = 'all 0.3s ease'
            marker.style.flexShrink = '0'
            // 选中的标记发光效果
            if (isActive && selectedItems.length > 0) {
              marker.style.boxShadow = `0 0 12px ${color}`
              marker.style.transform = 'scale(1.2)'
            }
            // 图例文字
            const text = document.createElement('span')
            text.textContent = d.type
            text.style.color = isActive ? '#00DADA' : 'rgba(255,255,255,0.8)'
            text.style.fontSize = '12px'
            text.style.fontWeight = isActive && selectedItems.length > 0 ? 'bold' : 'normal'
            text.style.transition = 'all 0.3s ease'
            text.style.display = 'inline-block'  // 确保 transform 生效
            // 超过 100% 时文字闪烁
            if (isOver) {
              text.style.animation = 'legend-text-blink 0.8s infinite'
            }
            itemDiv.appendChild(marker)
            itemDiv.appendChild(text)
            // 鼠标悬停效果
            itemDiv.addEventListener('mouseenter', () => {
              if (isActive) {
                // 字体放大
                text.style.fontSize = '13px'  // 从 12px 放大到 13px
                text.style.transform = 'scale(1.1)'
                // itemDiv.style.background = 'rgba(0, 218, 218, 0.1)'
                // 确保没有边框和阴影
                itemDiv.style.border = 'none'
                itemDiv.style.outline = 'none'
                itemDiv.style.boxShadow = 'none'
              }
            })
            itemDiv.addEventListener('mouseleave', () => {
              // 恢复字体大小
              text.style.fontSize = '12px'
              text.style.transform = 'scale(1)'
              itemDiv.style.background = 'transparent'
            })
            // 点击事件 - 多选模式，显示最后选中的详情,2026.09.16改为单选模式
            itemDiv.addEventListener('click', function(e) {
              e.stopPropagation()
              const idx = selectedItems.indexOf(d.type)
              if (idx > -1) {
                // 已选中 → 取消，清空选中
                selectedItems.length = 0 // 清空
                vm.closeDetail()
              } else {
                // 未选中 → 替换（清空后只放当前图例）
                selectedItems.length = 0 // 先清空，保证单选
                selectedItems.push(d.type)
                if (d.brandId) {
                  vm.getBrandDetail(d.brandId)
                } else {
                  vm.showBrandDetail(null, d.type)
                }
              }
              renderLegend()
              updateChart()
            })
            legendContainer.appendChild(itemDiv)
          })
        }
        // 初始渲染
        renderLegend()
      })
    },
    darkenColor(hex, amount = 0.25) {
      const c = hex.replace('#', '')
      const num = parseInt(
        c.length === 3
          ? c.split('').map(x => x + x).join('')
          : c,
        16
      )
      let r = (num >> 16) & 0xff
      let g = (num >> 8) & 0xff
      let b = num & 0xff
      r = Math.max(0, Math.floor(r * (1 - amount)))
      g = Math.max(0, Math.floor(g * (1 - amount)))
      b = Math.max(0, Math.floor(b * (1 - amount)))
      return '#' + [r, g, b].map(v => v.toString(16).padStart(2, '0')).join('')
    },
    async getAreaBrandDetails() {
      this.brandOriginColor = {}
      this.eOriginColor = {}
      if (this.selfAreaId !== '') {
        try {
          const params = {
            selfAreaId: this.selfAreaId
          }
          await Api.areaBrandDetails(params).then((res) => {
            if (res.code === 200) {
              const brandOriginColor = res.data.map(item => {
                return {
                  brandName: item.brandName.slice(0, 2) + '单车',
                  bikeColor: item.bikeColor
                }
              })
              // 单车
              const colorObject = brandOriginColor => {
                for (let i = 0; i < brandOriginColor.length; i++) {
                  const { brandName, bikeColor } = brandOriginColor[i]
                  this.brandOriginColor[brandName] = bikeColor
                }
                return this.brandOriginColor
              }
              this.brandOriginColor = colorObject(brandOriginColor)
              // 电动车
              const eBrandOriginColor = res.data.map(item => {
                if (item.brandName.indexOf('美团出行') > -1) {
                  return {
                    brandName: '美团电单',
                    eBikeColor: item.ebikeColor
                  }
                }
                return {
                  brandName: item.brandName,
                  eBikeColor: item.ebikeColor
                }
              })
              const eColorObject = eBrandOriginColor => {
                for (let i = 0; i < eBrandOriginColor.length; i++) {
                  const { brandName, eBikeColor } = eBrandOriginColor[i]
                  this.eOriginColor[brandName] = eBikeColor
                }
                return this.eOriginColor
              }
              this.eOriginColor = eColorObject(eBrandOriginColor)
            } else {
              console.log('汇总区域品牌信息为空 -TotalRingChart')
            }
          })
        } catch (e) {
          this.eOriginColor = {}
          this.brandOriginColor = {}
        }
      }
    },
    // 自行车品牌颜色
    originColor(name) {
      return this.brandOriginColor[name]
    },
    // 电动车品牌颜色
    eBrandOriginColor(name) {
      return this.eOriginColor[name]
    },
    color16() {
      var r = Math.floor(Math.random() * 256)
      var g = Math.floor(Math.random() * 256)
      var b = Math.floor(Math.random() * 256)
      var color = '#' + r.toString(16) + g.toString(16) + b.toString(16)
      return color
    },
    getColorsByNames() {
      const colorMap = {}
      for (let i = 0, len = this.realNames.length; i < len; i++) {
        const item = this.realNames[i]
        let color
        if (item.indexOf('单车') !== -1) {
          color = this.originColor(item) ? this.originColor(item) : this.color16()
        } else {
          color = this.eBrandOriginColor(item) ? this.eBrandOriginColor(item) : this.color16()
        }
        colorMap[item] = color
      }
      return colorMap
    },
    async initCircle1Data() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      if (!this.selfAreaId || this.userLevel < 2) {
        this.initCircle1([], 0)
        return
      }
      const params = {
        selfAreaId: this.selfAreaId
      }
      await Api.brandPercentNew(params).then((res) => {
        if (res.code === 200) {
          delete res.data.areaBikeNum
          delete res.data.areaEleBikeNum
          this.pinpaiSort = Object.keys(res.data || {})
          const tableData = this.translateData2(res.data)
          const cData = []
          const onlineTotal = Object.values(tableData).reduce((per, cur) => {
            if (this.isBicycle) {
              per += cur.PutBikeNum
            }
            if (this.isElectricBike) {
              per += cur.PutEBikeNum
            }
            return per
          }, 0) //  总在线量
          let setCountTotal = 0
          this.realNames = []
          for (const key in tableData) {
            if (!tableData[key]) {
              continue
            }
            // 保留原始数据
            tableData[key].PutBikeNumOrigin = tableData[key].PutBikeNum
            tableData[key].PutEBikeNumOrigin = tableData[key].PutEBikeNum
            // 数据修正
            tableData[key].PutBikeNum =
              tableData[key].PutBikeNum <= tableData[key].BrandBikeNum
                ? tableData[key].PutBikeNum
                : tableData[key].BrandBikeNum
            tableData[key].PutEBikeNum =
              tableData[key].PutEBikeNum <= tableData[key].BrandEBikeNum
                ? tableData[key].PutEBikeNum
                : tableData[key].BrandEBikeNum
            // 总核定量
            if (this.isBicycle) {
              setCountTotal += tableData[key].BrandEBikeNum
            }
            if (this.isElectricBike) {
              setCountTotal += tableData[key].BrandBikeNum
            }
            const curData = tableData[key]
            // 单车数据集
            if (this.isBicycle) {
              const tempBike = {
                type: this.getPinPaiName(key, 1), // key + '(单车)',
                key: 1,
                bili: this.getValue(
                  // 在线量占比
                  curData.PutBikeNumOrigin,
                  onlineTotal
                ),
                percent: this.getValue(
                  curData.PutBikeNumOrigin,
                  curData.BrandBikeNum
                ),
                online: curData.PutBikeNumOrigin,
                inSite: curData.SiteBikeNum,
                setCount: curData.BrandBikeNum,
                brandId: curData.BrandId
              }
              if (tempBike.online + tempBike.setCount > 0) {
                cData.push(tempBike)
                this.realNames.push(this.getPinPaiName(key, 1))
              }
            }
            // 电车数据集
            if (this.isElectricBike) {
              const tempEBike = {
                type: this.getPinPaiName(key, 2), // key + '(电动车)',
                key: 2,
                bili: this.getValue(
                  // 在线量占比
                  curData.PutEBikeNumOrigin,
                  onlineTotal
                ),
                percent: this.getValue(
                  // 在线量占比
                  curData.PutEBikeNumOrigin,
                  curData.BrandEBikeNum
                ),
                online: curData.PutEBikeNumOrigin,
                inSite: curData.SiteEBikeNum,
                setCount: curData.BrandEBikeNum,
                brandId: curData.BrandId
              }
              if (tempEBike.online + tempEBike.setCount > 0) {
                cData.push(tempEBike)
                this.realNames.push(this.getPinPaiName(key, 2))
              }
            }
          }
          this.timer = setTimeout(this.initCircle1Data, 180000) // 3分钟
          try {
            setTimeout(() => {
              this.initCircle1(cData, onlineTotal)
            }, 1500)
            this.cData = cData
            this.onlineTotal = onlineTotal
            // 在此运行代码
          } catch (err) {
            // 在此处理错误
            console.log('c3', err)
          }
        } else {
          this.initCircle1([], 0)
          console.log('品牌占比统计数据为空 - TotalRingChart')
        }
      })
    },
    getPinPaiName(originName, type) {
      // originName - 品牌原名，key：1-自行车，2-电动车
      if (type === 1) {
        return originName.slice(1).slice(0, 2) + '单车'
      } else if (type === 2) {
        if (originName.indexOf('美团出行') > -1) {
          return '美团电单'
        }
        return originName.slice(1)
      }
    },
    getValue(n, total) {
      if (n === 0 || total === 0) {
        return 0
      }
      return Number((Number(Number(n / total).toFixed(3)) * 100).toFixed(1))
    },
    translateData2(data) {
      let i = 1
      const pSort = {}
      for (const key of this.pinpaiSort) {
        pSort[i + key] = data[key]
        i++
      }
      return pSort
    },
    dashboardBike(legality) {
      this.$emit('dashboardBike', legality)
    },
    filterBike(brandId, bikeType) {
      if (brandId) {
        this.$emit('filterBike', {
          brandId,
          bikeType
        })
      } else {
        console.log(22222)
        this.$emit('filterBike', false)
      }
    },
    showModel(item, type, bikeType) {
      // type 1-企业，2-查看
      const params = {
        ...item,
        type,
        bikeType
      }
      this.$emit('showModel', params)
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    if (!this.Circle1) return
    this.Circle1.destroy()
    this.Circle1 = null
  }
}
</script>
<style lang="less">
/* 非 scoped，tooltip 挂在 body 上 闪烁样式 */
@keyframes tidal-percent-blink {
  0%, 100% { opacity: 1; }
  10% { opacity: 0.15; }
}
// 图例闪烁
@keyframes legend-text-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.15; }
}

@keyframes legend-marker-blink {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.2; transform: scale(0.7); }
}
</style>
<style scoped lang='less'>
.ring-box {
  display: flex;
  flex-direction: column;  // 改为纵向排列
  position: relative;
  height: 100%;
  overflow: hidden;  // 防止溢出

  #ring {
    flex: 0 0 auto;  // 不伸缩
    height: 220px;   // 固定高度，根据实际调整
    width: 100%;
    transition: transform 0.3s ease;  // 添加平滑过渡动画
    margin-top: -8px;
    // 当详情面板显示时，环形图向左移动
    &.ring-shift {
      transform: translateX(-100px);
    }
  }

  // 自定义图例容器
  ::v-deep #custom-legend-container {
    flex-shrink: 0;  // 不缩小
    min-height: 50px;  // 固定高度
    overflow-y: auto;  // 如果图例太多可以滚动
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
  }
  // ===== 详情面板样式 =====
  #brand-detail-panel {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 200px;
    background: rgba(2, 25, 34, 0.95);
    border: 1px solid rgba(0, 218, 218, 0.3);
    border-radius: 8px;
    padding: 8px 12px;
    box-shadow: 0 0 20px rgba(0, 218, 218, 0.15);
    z-index: 10;
    backdrop-filter: blur(4px);
    animation: detailFadeIn 0.3s ease;

    .detail-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      padding-bottom: 8px;
      border-bottom: 1px solid rgba(0, 218, 218, 0.2);

      .detail-title {
        font-size: 16px;
        font-weight: bold;
        color: #00DADA;
      }

      .detail-close {
        cursor: pointer;
        font-size: 20px;
        color: rgba(255, 255, 255, 0.6);
        transition: color 0.3s ease;
        line-height: 1;

        &:hover {
          color: #ff4d4f;
        }
      }
    }

    .detail-content {
      .detail-row {
        display: flex;
        padding: 2px 0;
        font-size: 13px;
        line-height: 1.4;

        .detail-label {
          color: rgba(255, 255, 255, 0.5);
          min-width: 70px;
          flex-shrink: 0;
        }

        .detail-value {
          color: rgba(255, 255, 255, 0.85);
          word-break: break-all;
        }
      }
    }
  }
}
// 详情面板淡入动画
@keyframes detailFadeIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/deep/.g2-tooltip {
  background: #021922 !important;
  box-shadow: 0px 0px 8px 0px rgba(0, 218, 218, 0.3) !important;
  .g2-tooltip-list {
    color: rgba(255, 255, 255, 0.85);
    font-size: 14px;
    .red {
      color: #ed462f;
    }
  }
}

.content {
  overflow: auto;
  flex: 1;
  display: flex;
  color: #00dada;
  .flex {
    display: flex;
    justify-content: space-between;
  }
  > .flex-1 {
    padding: 0 10px;
  }
  .flex-1 {
    flex: 1;
    .title {
      margin-top: 16px;
      margin-bottom: 16px;
      > div:first-child {
        margin-bottom: 16px;
        font-size: 14px;
        text-align: center;
        & + div {
          display: flex;
          justify-content: space-between;
        }
      }
      > div:last-child {
        span:first-child {
          cursor: pointer;
        }
      }
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      line-height: 14px;
    }
    .num {
      margin-bottom: 10px;
      font-size: 12px;
      display: flex;
      justify-content: space-around;
      line-height: 12px;
      span {
        flex: 1;
        text-align: left;
        &:first-child {
          flex: 0 0 5em;
        }
        // &:nth-child(2) {
        //   cursor: pointer;
        // }
        &:nth-child(4) {
          text-align: right;
        }
        &:last-child {
          flex: 0 0 2em;
          margin-left: 1em;
          cursor: pointer;
        }
      }
      .gray-a {
        color: rgba(255, 255, 255, 0.65);
      }
      .blue {
        color: #1f8ffb;
      }
      .red {
        color: #ed462f;
        margin-right: 8px;
      }
    }
  }
}
</style>
